import { render, staticRenderFns } from "./UserProfileLayout.vue?vue&type=template&id=359becb0&scoped=true&"
import script from "./UserProfileLayout.vue?vue&type=script&lang=ts&"
export * from "./UserProfileLayout.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileLayout.vue?vue&type=style&index=0&id=359becb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359becb0",
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QDrawer,QPageContainer,QPage,QScrollArea});
